/* eslint-disable jira/naming/disallow-filenames */

import React from 'react';
import type { VersionDetailSpa as LazyVersionDetailType } from '@jira/spa-apps__version-detail/src/VersionDetailSpa.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyVersionDetail: LazyComponent<() => React.JSX.Element> = lazyForPaint<
	typeof LazyVersionDetailType
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-jira-software-version-detail", jiraSpaEntry: "async-jira-software-version-detail" */ '@jira/spa-apps__version-detail/src/VersionDetail.tsx'
		),
	),
);

export const VersionDetailPage = (): React.JSX.Element => (
	<LazyPage Page={LazyVersionDetail} pageId="version-detail" shouldShowSpinner={false} />
);
